import React from 'react';
import { marked } from 'marked';

// parse the inline markdown
const parseInlineMarkdown = (text) => {
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/`([^`]+)`/g, '<code>$1</code>');
};

// parse the simple markdown (title, list, paragraph)
const simpleMarkdown = (text) => {
  if (!text) return '';

  const lines = text.split('\n');
  const result = [];
  let inList = false;
  let inParagraph = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (!line) {
      if (inList) { result.push('</ul>'); inList = false; }
      if (inParagraph) { result.push('</p>'); inParagraph = false; }
      continue;
    }

    if (line.startsWith('### ')) {
      if (inList) { result.push('</ul>'); inList = false; }
      if (inParagraph) { result.push('</p>'); inParagraph = false; }
      result.push('<h3>' + line.substring(4) + '</h3>');
      continue;
    }
    if (line.startsWith('## ')) {
      if (inList) { result.push('</ul>'); inList = false; }
      if (inParagraph) { result.push('</p>'); inParagraph = false; }
      result.push('<h2>' + line.substring(3) + '</h2>');
      continue;
    }
    if (line.startsWith('# ')) {
      if (inList) { result.push('</ul>'); inList = false; }
      if (inParagraph) { result.push('</p>'); inParagraph = false; }
      result.push('<h1>' + line.substring(2) + '</h1>');
      continue;
    }

    if (/^[-*+]\s+/.test(line)) {
      if (inParagraph) { result.push('</p>'); inParagraph = false; }
      if (!inList) { result.push('<ul>'); inList = true; }
      const listContent = line.replace(/^[-*+]\s+/, '');
      result.push('<li>' + parseInlineMarkdown(listContent) + '</li>');
      continue;
    }

    if (inList) { result.push('</ul>'); inList = false; }
    if (!inParagraph) { result.push('<p>'); inParagraph = true; }
    else { result.push('<br>'); }
    result.push(parseInlineMarkdown(line));
  }

  if (inList) result.push('</ul>');
  if (inParagraph) result.push('</p>');

  return result.join('');
};

// render the markdown content
const renderMarkdown = (text) => {
  try {
    return marked.parse(text);
  } catch (e) {
    return simpleMarkdown(text);
  }
};

const MarkdownContent = ({ text }) => {
  const htmlContent = renderMarkdown(text);
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default MarkdownContent;


